import BaseComponent from "../../common/BaseComponent";
import { Divider, Select } from "antd";
import { Select as AntdV5Select, ConfigProvider as ConfigProvider5 } from "antd-v5";

import "./index.scss";
import { NormalSelectV5Props } from "./types";
import { cn } from "utils/index";

export default class NormalSelect extends BaseComponent {
  render() {
    const {
      optionList,
      placeholder,
      placement = "bottomLeft",
      disabled = false,
      handleChange,
      handleSelect,
      handleDeSelect,
      handleSearch,
      handleFilterOption,
      handleFocus,
      defaultValue,
      mode,
      maxTagCount,
      showArrow,
      showSearch,
      className = "",
      value,
      status,
      handleMouseEnter,
      loading,
      getPopupContainer,
      onDropdownVisibleChange,
      open,
      dropdownStyle,
      isNeedSelectAll,
      handleSelectAll,
      handleDeselectAll,
      testid,
    } = this.props;

    return (
      <Select
        dropdownStyle={dropdownStyle}
        value={value}
        className={`${status} customSelectCompnent ${className}`}
        defaultValue={defaultValue}
        onChange={handleChange}
        placeholder={placeholder}
        placement={placement}
        disabled={disabled}
        mode={mode}
        maxTagCount={maxTagCount}
        showArrow={showArrow}
        showSearch={showSearch}
        onSelect={handleSelect}
        onDeselect={handleDeSelect}
        onSearch={handleSearch}
        onFocus={handleFocus}
        filterOption={handleFilterOption}
        onMouseEnter={handleMouseEnter}
        loading={loading}
        getPopupContainer={
          getPopupContainer
            ? getPopupContainer === "null"
              ? undefined
              : getPopupContainer
            : (triggerNode) => triggerNode.parentElement
        }
        onDropdownVisibleChange={onDropdownVisibleChange}
        open={open}
        data-testid={testid}
        dropdownRender={(menu) => (
          <>
            {isNeedSelectAll && (
              <>
                <div className="selectWithButtonButtonDiv">
                  <div
                    className="selectAllButton"
                    onClick={handleSelectAll}
                    data-testid={testid ? `${testid}-select-all` : undefined}
                  >
                    Select All
                  </div>
                  <div
                    className="selectAllButton"
                    onClick={handleDeselectAll}
                    data-testid={testid ? `${testid}-deselect-all` : undefined}
                  >
                    Deselect All
                  </div>
                </div>
                <Divider />
              </>
            )}
            {menu}
          </>
        )}
      >
        {optionList.map((item: any, idx: any) => (
          <Select.Option
            value={item.value}
            key={`${item.value}${idx}`}
            title={item.name}
            className="customSelectOption"
          >
            {item.name}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export class ScrollSelect extends BaseComponent {
  render() {
    const {
      optionList,
      placeholder,
      placement = "bottomLeft",
      disabled = false,
      handleChange,
      handleSelect,
      handleDeSelect,
      handleSearch,
      handleFilterOption,
      handleFocus,
      defaultValue,
      mode,
      maxTagCount,
      showArrow,
      showSearch,
      className = "",
      value,
      status,
      handleMouseEnter,
      loading,
      key,
      testid,
    } = this.props;

    return (
      <Select
        key={key}
        value={value}
        className={`${status} customScrollSelectComponent ${className}`}
        defaultValue={defaultValue}
        onChange={handleChange}
        placeholder={placeholder}
        placement={placement}
        disabled={disabled}
        mode={mode}
        maxTagCount={maxTagCount}
        showArrow={showArrow}
        showSearch={showSearch}
        onSelect={handleSelect}
        onDeselect={handleDeSelect}
        onSearch={handleSearch}
        onFocus={handleFocus}
        filterOption={handleFilterOption}
        onMouseEnter={handleMouseEnter}
        loading={loading}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        data-testid={testid}
      >
        {optionList.map((item: any, idx: any) => (
          <Select.Option
            value={item.value}
            key={`${item.value}${idx}`}
            title={item.name}
            className="customSelectOption"
          >
            {item.name}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

const NormalSelectV5 = (props: NormalSelectV5Props) => {
  const {
    optionList,
    handleChange,
    handleSelect,
    handleDeSelect,
    handleSearch,
    handleFilterOption,
    handleFocus,
    handleMouseEnter,
    onDropdownVisibleChange,
    isNeedSelectAll,
    handleSelectAll,
    handleDeselectAll,
    status,
    className = "",
    getPopupContainer,
    testid,
    ...restProps
  } = props;

  // Transform optionList to Antd v5 options format
  const options = optionList?.map((item) => ({
    label: item.name,
    value: item.value,
  }));

  return (
    <ConfigProvider5
      theme={{
        components: {
          Select: {
            borderRadius: 4,
            optionSelectedColor: "rgba(0, 0, 0, 0.85)",
            optionSelectedBg: "#e6f7ff",
            multipleItemBg: "#f5f5f5",
          },
        },
      }}
    >
      <AntdV5Select
        {...restProps}
        options={options}
        className={cn(`${status || ""} customSelectCompnentV5 ${className}`)}
        onChange={handleChange}
        onSelect={handleSelect}
        onDeselect={handleDeSelect}
        onSearch={handleSearch}
        filterOption={handleFilterOption}
        onFocus={handleFocus}
        onMouseEnter={handleMouseEnter}
        onOpenChange={onDropdownVisibleChange}
        getPopupContainer={
          getPopupContainer ? getPopupContainer : (triggerNode) => triggerNode.parentElement
        }
        data-testid={testid}
        popupRender={(menu) => (
          <>
            {isNeedSelectAll && (
              <>
                <div className="selectWithButtonButtonDiv">
                  <div
                    className="selectAllButton"
                    onClick={handleSelectAll}
                    data-testid={testid ? `${testid}-select-all` : undefined}
                  >
                    Select All
                  </div>
                  <div
                    className="selectAllButton"
                    onClick={handleDeselectAll}
                    data-testid={testid ? `${testid}-deselect-all` : undefined}
                  >
                    Deselect All
                  </div>
                </div>
                <Divider />
              </>
            )}
            {menu}
          </>
        )}
      />
    </ConfigProvider5>
  );
};

export { NormalSelectV5 };
